
import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles, makeStyles } from '@material-ui/core/styles';

const ThinOrangeProgress = withStyles({
  root: {
    height: 6,
    borderRadius: 3,
    backgroundColor: '#f5e6d1',
    width: '100%',
    margin: '8px 0',
  },
  bar: {
    borderRadius: 3,
    backgroundColor: '#FF7F27',
    transition: 'width 0.4s ease',
  },
})(LinearProgress);

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px 0',
  },
  progressContainer: {
    width: '90%',
  },
}));

export default function CustomizedProgressBar({ played = 0 }) {
  const classes = useStyles();
  const percent = Math.round(Math.max(0, Math.min(played * 100, 100)));

  return (
    <div className={classes.root}>
      <div className={classes.progressContainer}>
        <ThinOrangeProgress variant="determinate" value={percent} />
      </div>
    </div>
  );
}
